import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { catchError, map, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { User } from '@app/core/models/user.model';
import { HttpService } from '@app/core/services/http.service';
import { GET_USER_DETAILS, LOGOUT } from '@app/core/constants/apis-list.constant';
import { trimValue } from '@app/core/shared/helpers/trim-value';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends HttpService {
  public loggedIn = false;
  public userSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private _onDestroy$: Subject<void> = new Subject<void>();

  constructor(injector: Injector) {
    super(injector);
    this.setUserDetails();
  }

  setUserDetails(user: any = this.localService.get('wow-user')): void {
    this.user = new User(user || {});
    this.userSubject.next(this.user);
  }

  login() {
    return this.requestEntity('GET', GET_USER_DETAILS).pipe(
      map((response: any) => {
        // console.log(response);
        if (response?.status === this.constantList.SUCCESS_STATUS) {
          if (!response.body) {
            this.showMessage(`User doesn't exists!`, 'warning');
          }
          return response.body;
        }
        return null;
      }),
      tap(authResult => {
        if (authResult) {
          this.setLocalSession(authResult as any);
          this.loggedIn = true;
          return authResult;
        }
        this.loggedIn = false;
        return null;
      }),
      shareReplay(1),
      catchError(err => throwError(() => this.handleErrorMessages(err))),
    );
  }

  public logout() {
    this.requestEntity('DELETE', LOGOUT, null, this.formDataHeaders, false)
      .pipe(takeUntil(this._onDestroy$))
      .subscribe({
        complete: () => {
          this.setUserDetails(null);
          this.localService.clearDataInLocalStorage();
          this._onDestroy$.next();
          this._onDestroy$.complete();
          window.location.replace('/auth/login');
        },
      });
  }

  public isLoggedIn(): boolean {
    return this.localService.getToken();
  }

  /**
   * the following method will store info in the local session
   * @param authResult
   */
  setLocalSession(authResult: any) {
    // if (authResult?.profilePicture) {
    //   authResult.profilePicture = getLastModifiedImage('lastModified', authResult.profilePicture);
    // }
    trimValue(authResult.firstName);
    trimValue(authResult.lastName);
    this.localService.set({ key: 'wow-user-permissions', value: authResult.permissions || [] });
    this.updateUserDetails(authResult);
  }

  updateUserDetails(user: any = this.user): void {
    this.localService.setDataInLocalStorage({ key: 'wow-user', value: user });
    this.setUserDetails(user);
  }

  public get isServer(): boolean {
    return !this.localService.isBrowser;
  }

  public get isBrowser(): boolean {
    return this.localService.isBrowser;
  }
}
